import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { exchangeMagicLoginToken } from '../services/pendingEventsService';

const TOKEN_KEY = 'gise_panel_access_token';
const USER_KEY = 'gise_panel_user';

/**
 * Admin e-postasindaki "Panele git" — token ile login + event show.
 */
const MagicLoginPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setError('Bağlantıda token yok.');
      return undefined;
    }

    let cancelled = false;

    (async () => {
      try {
        const data = await exchangeMagicLoginToken(token);
        if (cancelled) return;
        localStorage.setItem(TOKEN_KEY, data.accessToken);
        localStorage.setItem(USER_KEY, JSON.stringify(data.user));
        const next = data.redirectTo || '/events-v2';
        window.location.hash = `#${next.startsWith('/') ? next : `/${next}`}`;
        window.location.reload();
      } catch (err) {
        if (!cancelled) {
          setError(err?.message || 'Giriş başarısız');
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [searchParams, navigate]);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        p: 3,
      }}
    >
      {error ? (
        <>
          <Typography color="error">{error}</Typography>
          <Typography
            component="a"
            href="#/login"
            sx={{ color: '#9c27b0', cursor: 'pointer' }}
          >
            Normal girişe dön
          </Typography>
        </>
      ) : (
        <>
          <CircularProgress />
          <Typography>Panele giriş yapılıyor…</Typography>
        </>
      )}
    </Box>
  );
};

export default MagicLoginPage;
